import { useCallback } from 'react';
import { healthCheckOrderResultUrl } from '@app/definition/API';
import apiClient from '@root/src/app/network/apiClient';
import { ResultOptionType } from '../../order/types';
import showNotification from '@designSystem/toastNotification/selectToast';
import Lang from '@lang/en';

export type SaveResultType = (
  id: number,
  result: ResultOptionType,
  image: string,
  sampleTakenAt: number,
  staticSampleTakenAt: string,
  reportedAt: number,
  staticReportedAt: string,
  method: string
) => Promise<void>;

const useSaveResult = (): {
  saveResult: SaveResultType;
} => {
  const saveResult = useCallback(
    async (
      id: number,
      result: ResultOptionType,
      image: string,
      sampleTakenAt: number,
      staticSampleTakenAt: string,
      reportedAt: number,
      staticReportedAt: string,
      method: string
    ): Promise<void> => {
      const url = healthCheckOrderResultUrl.replace('%id%', String(id));

      const res = await apiClient.patch(url, {
        result,
        image,
        sampleTakenAt,
        staticSampleTakenAt,
        reportedAt,
        staticReportedAt,
        method,
      });
      if (res.status === 200)
        showNotification({
          text: Lang.healthCheckSaveAddResultSuccessfully,
          type: 'success',
        });
    },
    []
  );

  return {
    saveResult,
  };
};

export default useSaveResult;
